export default __webpack_public_path__ + "images/streeingWheel.a3cdb30c.svg";